module.exports = __webpack_public_path__ + "static/media/enchanting-3.18bb8db9.png";